module.exports = __webpack_public_path__ + "static/media/crewlist_emptystate.cc2c2316.svg";